/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Auto-playing video with ADA play/pause + in-view playback
(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --- Play/pause button wiring (scoped to our mobile gif component only) ---
  function initVideoPauseBtns(scope) {
    (scope || document).querySelectorAll('[data-gif-pause-btn]:not([data-pause-initialized])').forEach(function (btn) {
      var videoWrapper = btn.closest('.TwoUpVideoDetails__MobileGifWrapper');
      if (!videoWrapper) return;
      var video = videoWrapper.querySelector('video');
      if (!video) return;

      btn.dataset.pauseInitialized = 'true';

      btn.addEventListener('click', function () {
        if (video.paused) {
          delete video.dataset.userPaused;
          video.play();
          btn.setAttribute('aria-label', 'Pause video');
          btn.querySelector('svg').innerHTML = '<rect x="1" y="1" width="4" height="12" rx="1"/><rect x="9" y="1" width="4" height="12" rx="1"/>';
        } else {
          video.dataset.userPaused = 'true';
          video.pause();
          btn.setAttribute('aria-label', 'Play video');
          btn.querySelector('svg').innerHTML = '<polygon points="2,1 13,7 2,13"/>';
        }
      });
    });

    if (reducedMotion) {
      (scope || document).querySelectorAll('.TwoUpVideoDetails__MobileGifWrapper video').forEach(function (video) {
        video.dataset.userPaused = 'true';
        video.pause();
      });
      (scope || document).querySelectorAll('[data-gif-pause-btn]').forEach(function (btn) {
        btn.setAttribute('aria-label', 'Play video');
        var svg = btn.querySelector('svg');
        if (svg) svg.innerHTML = '<polygon points="2,1 13,7 2,13"/>';
      });
    }
  }

  // --- IntersectionObserver: play when in view, pause when out (our gif videos only) ---
  function initVideoInView(scope) {
    if (reducedMotion || !window.IntersectionObserver) return;

    (scope || document).querySelectorAll('.TwoUpVideoDetails__MobileGifWrapper video:not([data-inview-initialized])').forEach(function (video) {
      video.dataset.inviewInitialized = 'true';

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!video.dataset.userPaused) {
              video.play().catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.3 });

      observer.observe(video);
    });
  }

  function init(scope) {
    initVideoPauseBtns(scope);
    initVideoInView(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (evt) { init(evt.target); });
})();

// --- Two-Up Video Details B: mobile pill play/pause + reversible desktop poster/video toggle ---
(function () {
  var WRAPPER_SEL = '[id^="two-up-video-details-wrapper-"]';

  function setMobilePillState(wrapper, playing, focusSwap) {
    var video = wrapper.querySelector('.TwoUpVideoDetails__MobilePillVideo');
    var pill = wrapper.querySelector('[data-mobile-pill-play]');
    var pauseBtn = wrapper.querySelector('[data-mobile-pill-pause]');
    if (!video) return;

    if (playing) {
      video.muted = true;
      // swap controls immediately — waiting for the play() promise leaves the pill
      // focused during buffering, so a second activation re-fires play
      if (pill) pill.style.display = 'none';
      if (pauseBtn) pauseBtn.style.display = 'flex';
      if (focusSwap && pauseBtn) pauseBtn.focus();
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          if (pauseBtn) pauseBtn.style.display = 'none';
          if (pill) { pill.style.display = ''; if (focusSwap) pill.focus(); }
        });
      }
    } else {
      video.pause();
      if (pauseBtn) pauseBtn.style.display = 'none';
      if (pill) { pill.style.display = ''; if (focusSwap) pill.focus(); }
    }
  }

  function toggleDesktopVideo(btn) {
    var slot = btn.parentElement;
    var container = btn.closest('.TwoUpVideoDetails__VideoContainer');
    var poster = slot.querySelector('.TwoUpVideoDetails__PosterImageWrapper') || (container && container.querySelector('.TwoUpVideoDetails__PosterImageWrapper'));
    var videoWrapper = slot.querySelector('.TwoUpVideoDetails__VideoWrapper');
    var iframe = slot.querySelector('.TwoUpVideoDetails__IframeVideo');
    var shopifyVideo = slot.querySelector('.TwoUpVideoDetails__ShopifyVideo');
    if (!videoWrapper) return;

    var isOpen = btn.getAttribute('data-video-open') === 'true';

    if (!isOpen) {
      if (!btn.dataset.originalLabel) btn.dataset.originalLabel = btn.innerHTML;
      if (poster) poster.classList.add('hide');
      videoWrapper.classList.remove('hide');
      if (btn.dataset.vidSrc === 'youtube_vimeo_src' && iframe) {
        iframe.src = (iframe.getAttribute('data-src') || '') + '&autoplay=1';
      } else if (shopifyVideo) {
        shopifyVideo.play();
      }
      btn.setAttribute('data-video-open', 'true');
      btn.innerHTML = 'Close video';
    } else {
      if (btn.dataset.vidSrc === 'youtube_vimeo_src' && iframe) {
        iframe.src = '';
      } else if (shopifyVideo) {
        shopifyVideo.pause();
      }
      videoWrapper.classList.add('hide');
      if (poster) poster.classList.remove('hide');
      btn.setAttribute('data-video-open', 'false');
      btn.innerHTML = btn.dataset.originalLabel;
    }
  }

  // Capture-phase delegation: runs before (and suppresses, via stopPropagation) the legacy
  // one-way #playVideoBtn handler that sdg-app.js binds directly on the button.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var wrapper = e.target.closest(WRAPPER_SEL);
    if (!wrapper) return;

    var pill = e.target.closest('[data-mobile-pill-play]');
    if (pill) { setMobilePillState(wrapper, true, e.detail === 0); return; }

    var pauseBtn = e.target.closest('[data-mobile-pill-pause]');
    if (pauseBtn) { setMobilePillState(wrapper, false, e.detail === 0); return; }

    var pillVideo = e.target.closest('.TwoUpVideoDetails__MobilePillVideo');
    if (pillVideo) { setMobilePillState(wrapper, pillVideo.paused, false); return; }

    var playBtn = e.target.closest('#playVideoBtn');
    if (playBtn) {
      e.stopPropagation();
      e.preventDefault();
      toggleDesktopVideo(playBtn);
    }
  }, true);
})();

(function () {
  function resetCard(card) {
    const btn = card.querySelector('.js-video-play-btn');
    const poster = card.querySelector('.js-video-poster');
    const wrapper = card.querySelector('.js-video-wrapper');
    if (btn) btn.classList.remove('hide');
    if (poster) poster.classList.remove('hide');
    if (!wrapper) return;
    wrapper.classList.add('hide');
    const iframe = wrapper.querySelector('iframe');
    const video = wrapper.querySelector('video');
    if (iframe) iframe.src = '';
    if (video) {
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    const btn = e.target.closest('.UGCSlider .js-video-play-btn');
    if (!btn) return;
    e.stopPropagation();

    const clickedCard = btn.closest('.Video');
    const slider = btn.closest('.UGCSlider');
    if (slider) {
      slider.querySelectorAll('.Video').forEach(function (card) {
        if (card !== clickedCard) resetCard(card);
      });
    }

    const container = btn.parentElement;
    const poster = container.querySelector('.js-video-poster');
    const wrapper = container.querySelector('.js-video-wrapper');
    if (!wrapper) return;
    const iframe = wrapper.querySelector('iframe');
    const video = wrapper.querySelector('video');

    btn.classList.add('hide');
    if (poster) poster.classList.add('hide');
    wrapper.classList.remove('hide');

    if (btn.dataset.vidSrc === 'youtube_vimeo_src' && iframe) {
      iframe.muted = true;
      iframe.src = (iframe.getAttribute('data-src') || '') + '&autoplay=1';
    } else if (video) {
      video.play();
      video.loop = true;
    }
  }, true);

  document.addEventListener('pause', function (e) {
    const video = e.target;
    if (!video || video.tagName !== 'VIDEO' || !video.closest) return;
    const card = video.closest('.UGCSlider .Video');
    if (card) resetCard(card);
  }, true);
})();

(function () {
  function warm(video) {
    if (!video || video.dataset.warmed) return;
    video.dataset.warmed = '1';
    video.preload = 'auto';
    try { video.load(); } catch (e) {}
  }

  function warmCard(card) {
    warm(card.querySelector('.js-video-wrapper video'));
  }

  function observe(scope) {
    const cards = (scope || document).querySelectorAll('.UGCSlider .Video:not([data-warm-observed])');
    if (!cards.length) return;

    if (!window.IntersectionObserver) {
      cards.forEach(function (c) { c.dataset.warmObserved = '1'; warmCard(c); });
      return;
    }

    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          warmCard(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });

    cards.forEach(function (c) { c.dataset.warmObserved = '1'; io.observe(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(document); });
  } else {
    observe(document);
  }

  document.addEventListener('shopify:section:load', function (evt) { observe(evt.target); });
})();

// --- PDP dropdowns (delegated, no double-binding) ---
(function () {
  function collapseAll(scope = document) {
    scope.querySelectorAll('[data-dropdown].js-isOpen').forEach((dd) => {
      dd.classList.remove('js-isOpen');
      const content = dd.querySelector('[data-dropdown-content]');
      const toggle = dd.querySelector('[data-dropdown-toggle]');
      if (content) content.style.maxHeight = null;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  // Toggle on click of any [data-dropdown-toggle] — accordion (only one open)
  document.addEventListener('click', (e) => {
    const toggle   = e.target.closest('[data-dropdown-toggle]');
    if (!toggle) return;

    const dropdown = toggle.closest('[data-dropdown]');
    const content  = dropdown?.querySelector('[data-dropdown-content]');
    if (!dropdown || !content) return;

    e.preventDefault();

    const isOpen = dropdown.classList.contains('js-isOpen');

    if (isOpen) {
      // close the one you clicked
      dropdown.classList.remove('js-isOpen');
      content.style.maxHeight = null;
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      // close others, then open this one
      collapseAll(document);
      dropdown.classList.add('js-isOpen');
      content.style.maxHeight = content.scrollHeight + 'px';
      toggle.setAttribute('aria-expanded', 'true');
    }
  });

  // Click outside to close
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-dropdown]')) return;
    collapseAll();
  });

  // Ensure closed state on initial load & when sections re-render in the editor
  function prime(scope = document) {
    scope.querySelectorAll('[data-dropdown]').forEach((dd) => {
      const toggle = dd.querySelector('[data-dropdown-toggle]');
      const content = dd.querySelector('[data-dropdown-content]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (content) content.style.maxHeight = null;
      dd.classList.remove('js-isOpen');
    });
  }

  document.addEventListener('DOMContentLoaded', () => prime(document));
  document.addEventListener('shopify:section:load', (evt) => prime(evt.target || document));
})();

/* -------------------------------------------------------------------------- */
/*  Upsell ATC -> AJAX add + open cart drawer                                 */
/*  Works even if a 'return_to=/checkout' or checkout submitter sneaks in.     */
/* -------------------------------------------------------------------------- */
(function () {
  if (window.__upsellAtcBound) return;
  window.__upsellAtcBound = true;

  // Prevent click on any checkout-like buttons inside upsell forms
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button, input[type="submit"]');
    if (!btn) return;
    const form = btn.closest('.js-upsell-atc');
    if (!form) return;

    // If this button is a checkout trigger, block it and fall back to AJAX add
    const isCheckoutBtn =
      btn.name === 'checkout' ||
      /checkout/i.test(btn.value || '') ||
      btn.getAttribute('data-checkout') === 'true';
    if (isCheckoutBtn) {
      e.preventDefault();
      form.requestSubmit(form.querySelector('button[type="submit"], input[type="submit"]')); // will be caught below
    }
  }, true);

  // Intercept submit and force AJAX add
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('.js-upsell-atc');
    if (!form) return;

    e.preventDefault();

    // Nuke any 'return_to' that would cause redirect
    const rt = form.querySelector('input[name="return_to"]');
    if (rt) rt.parentNode.removeChild(rt);

    // Also ignore if the submitting control was a checkout button
    const submitter = e.submitter;
    if (submitter && (submitter.name === 'checkout' || /checkout/i.test(submitter.value || ''))) {
      // fall through to AJAX add instead of redirect
    }

    const id = form.querySelector('input[name="id"]')?.value;
    const quantity = Number(form.querySelector('input[name="quantity"]')?.value || 1);
    if (!id) return;

    const addUrl = (window.routes?.cartAddUrl || '/cart/add') + '.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity })
    })
      .then((res) => {
        if (!res.ok) return res.json().then((err) => Promise.reject(err));
        return res.json();
      })
      .then((item) => {
        // Same events your theme listens to
        document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: item }));
        document.dispatchEvent(new CustomEvent('updateCount'));
      })
      .catch(() => {});
  }, true);
})();
